export const getQueryParam = (param) => {
  return new URL(window.location.href).searchParams.get(param);
};
